import { Pipe, PipeTransform } from '@angular/core';
import { compare } from 'src/app/globals';
import { EMailAudit } from '../classes';

@Pipe({
  name: 'sortEMails'
})
export class SortEMailsPipe implements PipeTransform {

  transform(eMails: EMailAudit[]): EMailAudit[] {
    if(!Array.isArray(eMails)) return [];
    return eMails.sort((x, y) => compare(x.received, y.received, false));
  }

}
